import { z } from "zod";
import { REVISION_ID_MAX_LENGTH } from "../file-versions";
import { fileNameSchema, sanitizedNullableString } from "../validation";

/** Lower-case hex SHA-256 digest, as produced by the browser upload hasher. */
export const sha256HashSchema = z.string().regex(/^[a-f0-9]{64}$/);

/** User-assigned, non-unique FileVersion label. Empty/whitespace → null. */
export const revisionIdSchema = sanitizedNullableString({
	max: REVISION_ID_MAX_LENGTH,
});

export const checkUploadConflictsInputSchema = z.object({
	folderId: z.uuid(),
	files: z
		.array(z.object({ name: fileNameSchema, fileHash: sha256HashSchema }))
		.min(1)
		.max(500),
});

export const getReplaceUploadUrlInputSchema = z.object({
	fileId: z.uuid(),
	name: fileNameSchema,
	size: z.number().int().positive(),
	mimeType: z.string(),
});

export const completeReplaceInputSchema = z.object({
	fileId: z.uuid(),
	expectedCurrentInstanceId: z.uuid(),
	s3Key: z.string(),
	name: fileNameSchema,
	size: z.number().int().positive(),
	mimeType: z.string(),
	fileHash: sha256HashSchema,
	revisionId: revisionIdSchema,
});

export const updateRevisionIdInputSchema = z.object({
	fileInstanceId: z.uuid(),
	revisionId: revisionIdSchema,
});

export type CheckUploadConflictsInput = z.infer<
	typeof checkUploadConflictsInputSchema
>;
export type CompleteReplaceInput = z.infer<typeof completeReplaceInputSchema>;
export type UpdateRevisionIdInput = z.infer<typeof updateRevisionIdInputSchema>;
